
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Ce que signifient les niveaux de danger</div>
    <p>{`Notre cartes comprend trois niveaux de danger: élevé, moyen et faible, qui sont symbolisés par les couleurs rouge, orange et jaune.`}</p>
    <div className='swatchContainer'>
      <div className='swatch subst ava' />
      <div className='swatch subst water' />
    </div>
    <b>Le danger élevé </b>signifie que «les personnes sont en danger à l’intérieur et à l’extérieur des bâtiments» et qu’il «faut s’attendre à des destructions soudaines de bâtiments», selon la définition officielle. La construction de nouveaux bâtiments est interdite dans ces zones. Les constructions existantes sont généralement laissées en place, mais leur utilisation ou transformation sont soumises à conditions.
    <br /><br />
    <div className='swatchContainer'>
      <div className='swatch mean ava' />
      <div className='swatch mean water' />
    </div>
    <b>Le danger moyen </b>veut dire que «les personnes ne sont guère en danger à l’intérieur des bâtiments, mais elles le sont à l’extérieur. Il faut s’attendre à des dommages aux bâtiments, mais des destructions soudaines sont improbables.» Il faut en principe s’abstenir d’ériger de nouveaux bâtiments dits «sensibles» (écoles, hôpitaux…) dans ces zones.
    <br /><br />
    <div className='swatchContainer'>
      <div className='swatch slight ava' />
      <div className='swatch slight water' />
    </div>
    <b>La zone de danger faible</b>ou jaune indique un danger «presque inexistant» pour les personnes, mais «des dommages matériels importants peuvent (…) survenir à l’intérieur des bâtiments». La création d’installations sensibles comme les écoles, les hôpitaux ou les campings ne doit se faire qu’avec retenue.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;